import { styled } from '@mui/material/styles';

/**
 * Stripe Card Elements look & feel shared by the saved-card form (BuiltInPaymentForm) and the
 * inline checkout card form (InlineCardForm): wrappers around the Stripe iframes and the
 * element style options. Kept in one place so both forms stay visually identical.
 */

export const CardInputWrapper = styled('div')(({ theme }) => ({
  border: 'solid 1px #d5d8dd',
  borderRadius: theme.spacing(0.75),
  padding: theme.spacing(1.25, 2),
  marginRight: theme.spacing(3),
  marginBottom: theme.spacing(3),
  height: theme.spacing(5),
  backgroundColor: '#FAFBFF',
}));

export const CardNameWrapper = styled('div')(({ theme }) => ({
  border: 'solid 1px #d5d8dd',
  borderRadius: theme.spacing(0.75),
  padding: theme.spacing(0.5, 2),
  marginBottom: theme.spacing(3),
  height: theme.spacing(5),
  backgroundColor: '#FAFBFF',
}));

export const CardInputEndWrapper = styled('div')(({ theme }) => ({
  border: 'solid 1px #d5d8dd',
  borderRadius: theme.spacing(0.75),
  padding: theme.spacing(1.25, 2),
  marginBottom: theme.spacing(3),
  height: theme.spacing(5),
  backgroundColor: '#FAFBFF',
}));

const BASE_ELEMENT_STYLE = {
  base: {
    fontSize: '14px',
    fontSmoothing: 'antialiased',

    ':focus': {
      color: '#081D36',
    },
    '::placeholder': {
      color: '#A1A9B3',
    },
    ':focus::placeholder': {
      color: '#CFD7DF',
    },
  },
  invalid: {
    color: '#ff8080',
    ':focus': {
      color: '#ff5050',
    },
    '::placeholder': {
      color: '#FFCCA5',
    },
  },
};

export const NUMBER_OPTIONS = {
  style: BASE_ELEMENT_STYLE,
  placeholder: '---- ---- ---- ----',
};
export const CARD_CVC_OPTIONS = {
  style: BASE_ELEMENT_STYLE,
  placeholder: 'CVC',
};
export const CARD_EXP_OPTIONS = {
  style: BASE_ELEMENT_STYLE,
  placeholder: 'MM / YY',
};
